import React from "react";

const NftColoring = ({ fillColors, onFill }) => {
  return (
    <div>
    <svg width="468pt" height="411.3pt" viewBox="0 0 720 657" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
    <title>NftColoring</title>
    <g transform="translate(0.00000,600.000000) scale(0.090000,-0.090000)" fill="#000000" stroke="none">
            <path
              id="svg_01"
              d="M0 3285 l0 -3285 690 0 690 0 0 58 c0 208 28 666 65 1077 42 455 46
              471 177 573 247 193 340 274 514 447 224 223 379 419 464 590 8 16 48 63 88
              103 39 41 74 83 76 95 16 88 39 173 57 211 24 53 73 104 107 113 27 6 34 19
              66 115 76 234 115 470 123 743 5 176 3 215 -16 327 -12 70 -21 152 -20 181 3
              64 -23 107 -121 202 -34 33 -75 79 -90 101 -37 53 -135 276 -156 357 -23 86
              -23 249 1 441 l20 158 41 -6 c195 -26 472 -292 544 -521 7 -22 15 -43 19 -47
              4 -5 23 13 43 40 l36 47 -8 101 c-6 86 -18 131 -80 316 -56 169 -82 233 -121
              294 -55 87 -63 130 -26 139 48 12 291 -75 426 -154 64 -38 161 -111 205 -155
              72 -72 140 -155 171 -211 32 -58 66 -95 87 -95 13 0 9 87 -8 163 -21 91 -76
              202 -165 336 -61 91 -68 106 -56 119 13 12 23 12 77 -7 190 -66 360 -207 548
              -456 73 -97 83 -114 78 -142 -3 -20 0 -33 6 -33 32 0 215 -140 325 -248 125
              -123 163 -178 163 -233 0 -30 1 -31 32 -25 18 4 143 27 278 52 242 44 263 51
              390 118 25 13 55 27 68 31 27 8 27 2 7 -97 -37 -176 -141 -315 -349 -467 -62
              -46 -193 -115 -239 -127 -16 -3 -31 -13 -34 -20 -6 -16 98 -171 228 -338 13
              -17 24 -45 25 -70 1 -22 14 -69 29 -103 53 -129 56 -218 10 -310 -14 -26 -25
              -58 -25 -71 0 -12 -9 -40 -20 -62 -11 -22 -20 -50 -20 -62 -1 -42 -38 -108
              -92 -161 -40 -40 -87 -70 -192 -122 -103 -52 -144 -78 -157 -100 -19 -30 -19
              -30 -19 -5 0 14 9 40 20 58 23 37 13 43 -16 10 -71 -80 -75 -147 -21 -318 62
              -195 68 -255 53 -500 -9 -159 -12 -142 55 -320 29 -77 32 -98 36 -219 l3 -134
              60 -106 c76 -137 140 -273 140 -301 0 -12 20 -63 45 -114 54 -112 88 -245 120
              -472 28 -196 49 -520 43 -677 l-3 -107 853 0 852 0 0 3285 0 3285 -3600 0
              -3600 0 0 -3285z"
              onClick={() => onFill(0)}
              fill={fillColors[0]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_02"
              d="M3875 6230 c3 -5 15 -10 26 -10 10 0 19 -7 19 -15 0 -9 6 -12 17 -8
              12 5 15 2 11 -9 -10 -26 6 -42 30 -29 30 16 31 15 25 -29 l-6 -40 32 11 c31
              11 56 5 35 -9 -6 -4 -14 -19 -18 -34 -6 -27 -6 -27 21 -12 37 18 73 18 73 -1
              0 -9 -9 -15 -24 -15 -27 0 -30 -3 -40 -42 -6 -26 -5 -26 22 -13 36 18 112 30
              112 18 0 -5 -17 -14 -37 -19 -26 -6 -43 -19 -56 -42 -11 -18 -17 -35 -15 -37
              3 -3 31 4 63 15 63 22 85 25 85 11 0 -5 -14 -11 -32 -15 -46 -9 -74 -30 -86
              -66 -10 -28 -10 -29 8 -20 27 14 160 25 160 13 0 -6 -21 -13 -46 -16 -48 -5
              -98 -41 -107 -78 -4 -15 -1 -18 16 -14 12 3 36 7 52 9 17 2 57 7 89 11 81 11
              66 -9 -20 -25 -38 -7 -76 -22 -91 -34 l-24 -21 120 4 c84 2 121 0 121 -8 0 -6
              -18 -11 -44 -11 -24 0 -59 -7 -77 -15 -33 -15 -32 -15 46 -11 44 3 97 8 117
              12 l38 6 -70 102 c-130 191 -265 335 -396 423 -80 55 -166 91 -149 63z m420
              -429 c3 -5 2 -12 -3 -15 -5 -3 -9 1 -9 9 0 17 3 19 12 6z"
              onClick={() => onFill(1)}
              fill={fillColors[1]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_03"
              d="M3190 6209 c0 -8 11 -28 36 -67 1 -2 11 2 23 9 11 7 24 9 28 5 4 -5
              2 -11 -4 -13 -7 -3 -13 -18 -13 -35 0 -30 0 -30 18 -10 19 22 68 37 76 23 3
              -5 -3 -11 -14 -14 -16 -4 -20 -14 -20 -53 0 -40 2 -45 13 -32 19 24 106 70
              125 66 12 -3 4 -11 -25 -26 -38 -20 -42 -26 -50 -74 -5 -29 -8 -58 -5 -65 2
              -6 24 8 50 33 50 46 117 82 130 69 4 -4 2 -10 -4 -12 -6 -2 -31 -17 -56 -32
              -40 -25 -46 -35 -60 -87 -8 -33 -19 -68 -23 -78 -15 -35 14 -7 33 31 23 47
              153 120 195 109 15 -3 27 -13 27 -21 0 -17 -5 -18 -28 -6 -23 12 -86 -14 -76
              -30 4 -8 3 -9 -4 -5 -7 4 -20 -7 -33 -29 -12 -19 -30 -40 -40 -46 -14 -7 -19
              -20 -18 -47 l0 -37 16 32 c18 37 32 44 137 78 93 29 146 33 146 9 0 -12 -6
              -15 -25 -10 -47 12 -107 -12 -156 -62 -25 -26 -56 -54 -67 -62 -12 -8 -24 -28
              -28 -45 l-7 -30 22 27 c47 59 178 108 288 108 74 0 66 -16 -12 -23 -36 -4 -80
              -13 -98 -22 -32 -15 -89 -64 -116 -97 -12 -16 -10 -17 30 -4 24 8 69 21 99 31
              30 9 90 19 133 22 69 5 77 4 77 -12 0 -13 -6 -16 -26 -12 -62 12 -254 -36
              -254 -63 0 -4 17 1 38 12 31 16 50 19 115 14 66 -5 82 -2 110 14 17 11 40 20
              50 20 48 0 -123 216 -238 300 -27 20 -81 55 -120 78 -83 49 -319 154 -351 156
              -12 0 -20 4 -18 7 2 4 -3 9 -11 13 -8 3 -15 1 -15 -5z m284 -297 c3 -5 -1 -9
              -9 -9 -8 0 -12 4 -9 9 3 4 7 8 9 8 2 0 6 -4 9 -8z"
              onClick={() => onFill(2)}
              fill={fillColors[2]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_04"
              d="M2744 5835 c-3 -14 -4 -129 -2 -257 5 -250 10 -278 68 -403 15 -33
              44 -94 63 -136 27 -59 54 -97 130 -177 53 -56 104 -116 113 -134 10 -20 20
              -73 24 -138 16 -211 98 -520 183 -690 63 -127 62 -124 51 -117 -5 3 -31 48
              -59 101 -27 53 -51 92 -53 87 -5 -16 47 -159 87 -240 22 -43 63 -103 91 -134
              29 -32 48 -57 43 -57 -9 0 -75 72 -156 170 -56 68 -109 160 -139 243 l-23 62
              -12 -115 c-16 -147 -56 -350 -94 -475 -46 -156 -38 -277 24 -355 28 -36 278
              -215 479 -343 110 -70 153 -92 214 -107 98 -25 146 -26 168 -1 51 56 16 328
              -66 516 -42 95 -83 158 -198 300 -117 143 -202 279 -199 318 0 7 9 -7 19 -30
              35 -78 86 -147 210 -283 130 -144 212 -258 261 -366 35 -76 73 -180 88 -239
              26 -105 33 -127 37 -122 15 15 -57 363 -100 487 -40 113 -23 94 24 -27 75
              -194 124 -397 135 -555 3 -46 9 -108 12 -138 l6 -55 11 65 c18 106 41 76 46
              -60 2 -58 3 -62 12 -35 5 17 10 100 11 185 1 119 -3 170 -16 219 -10 35 -15
              66 -13 69 5 4 16 -32 36 -118 20 -88 23 -298 6 -500 -16 -193 -21 -348 -11
              -338 5 4 13 49 51 271 9 54 18 96 21 93 2 -2 -1 -57 -7 -121 -14 -132 -9 -208
              20 -314 27 -94 50 -139 152 -291 46 -69 90 -140 97 -157 7 -18 17 -33 22 -33
              13 0 15 -6 -55 187 -119 334 -146 534 -105 796 6 37 14 67 19 67 4 0 8 -87 8
              -192 -1 -231 10 -303 87 -588 30 -113 55 -213 55 -222 0 -10 4 -18 8 -18 16 0
              47 215 46 325 -1 99 -3 115 -28 162 -14 29 -36 87 -47 130 -18 67 -20 96 -15
              213 3 74 9 137 14 142 4 4 7 -52 8 -125 1 -161 14 -214 89 -366 65 -131 90
              -217 106 -361 20 -191 62 -345 52 -193 -3 44 3 115 16 198 23 138 29 314 12
              355 -5 14 -19 39 -31 55 -30 44 -60 150 -59 209 l1 51 9 -39 c11 -47 83 -195
              139 -286 22 -36 47 -85 55 -110 14 -44 14 -44 9 50 -9 147 -52 298 -149 525
              -33 78 4 18 69 -111 42 -84 75 -168 92 -230 14 -55 28 -101 31 -104 3 -3 2 27
              -2 65 -7 68 -21 116 -83 295 -48 135 -112 459 -99 492 3 7 6 1 6 -13 1 -35 69
              -281 81 -293 7 -7 10 44 10 141 0 168 -12 243 -62 393 -38 113 -44 213 -15
              269 21 42 22 57 1 40 -22 -18 -42 -60 -54 -115 -10 -45 -5 -111 16 -204 4 -20
              1 -17 -14 10 -11 19 -25 59 -32 89 -14 60 -9 186 9 204 6 6 11 14 11 18 0 4
              -44 11 -97 16 l-98 8 75 5 c42 3 74 9 73 15 -1 6 42 23 95 38 53 15 122 39
              152 53 l55 25 -37 -36 c-21 -19 -35 -35 -31 -35 18 0 123 44 123 51 0 5 5 9
              10 9 6 0 4 -13 -5 -30 -9 -16 -13 -30 -10 -30 18 0 66 34 98 69 20 23 40 41
              44 41 3 0 -2 -9 -12 -20 -27 -30 -5 -24 31 8 31 26 94 109 94 121 0 4 -57 5
              -127 3 -245 -8 -473 54 -610 165 -24 19 -43 39 -43 44 0 6 19 -6 42 -26 78
              -66 178 -102 365 -130 115 -17 267 -19 327 -4 48 12 102 50 93 66 -4 5 -79 13
              -174 16 -248 10 -414 36 -533 83 -85 33 -168 94 -192 139 -6 11 12 -1 39 -27
              28 -25 74 -57 104 -71 103 -47 307 -77 519 -77 100 0 109 2 115 20 14 45 -30
              155 -68 169 -32 12 -200 165 -231 210 -30 43 -35 101 -10 122 23 19 173 22
              277 6 48 -7 87 -12 87 -10 0 2 -20 28 -45 59 -25 30 -115 160 -199 287 -85
              128 -166 243 -179 255 -45 42 -43 67 8 149 52 85 62 120 45 154 -7 13 -73 84
              -147 156 -169 166 -304 257 -368 249 -122 -17 -181 -18 -223 -3 -31 11 -66 13
              -121 10 -60 -4 -84 -2 -109 11 -35 18 -67 14 -117 -15 -38 -23 -65 -25 -146
              -16 -94 12 -132 -6 -217 -102 -38 -42 -96 -114 -131 -159 -60 -81 -62 -85 -56
              -130 5 -38 -1 -28 -30 53 -44 124 -67 172 -120 256 -87 136 -219 251 -382 333
              l-73 36 -6 -25z m119 -199 c10 -64 19 -92 35 -108 12 -12 24 -19 27 -16 3 3 8
              28 11 55 5 36 2 58 -11 82 -9 18 -15 35 -12 37 9 10 82 -147 102 -221 l22 -80
              17 39 c19 44 21 98 5 128 -7 14 -8 18 0 14 18 -12 31 -78 31 -166 l0 -85 52
              -19 c53 -18 108 -64 108 -88 0 -8 -4 -7 -11 5 -5 9 -23 24 -38 31 -25 13 -32
              13 -64 -2 -20 -9 -36 -20 -37 -24 0 -4 41 -48 91 -98 51 -49 88 -90 83 -90 -5
              0 -15 9 -21 20 -14 21 -53 44 -95 54 -39 9 -37 -11 11 -109 22 -44 39 -81 38
              -82 -1 -1 -22 27 -47 62 -48 68 -60 77 -60 45 0 -11 -4 -20 -10 -20 -5 0 -13
              -24 -17 -52 l-7 -53 -7 62 c-10 78 -39 183 -51 183 -5 0 -21 -27 -35 -60 -30
              -68 -41 -75 -18 -10 11 32 13 51 5 74 -5 17 -12 48 -15 69 -5 33 -9 37 -28 31
              -12 -3 -26 -10 -32 -15 -23 -22 -23 -5 1 30 l26 40 -30 38 c-17 21 -39 69 -50
              108 -29 101 -31 115 -21 115 5 0 9 -11 9 -25 0 -30 22 -76 44 -94 14 -11 16
              -11 16 5 0 11 -5 37 -10 59 -6 22 -15 74 -20 115 -5 41 -12 86 -16 100 -5 19
              -4 22 5 14 6 -6 17 -50 24 -98z m1072 -311 c74 -18 97 -35 163 -121 79 -104
              82 -115 10 -49 -88 82 -186 158 -223 172 -41 16 -22 15 50 -2z m915 -152 c-39
              -70 -71 -118 -66 -98 2 11 7 38 11 59 4 26 18 50 38 69 38 35 46 22 17 -30z
              m-984 24 c41 -16 127 -85 151 -122 34 -52 46 -98 39 -148 -4 -26 -10 -47 -14
              -47 -4 0 -20 27 -35 60 -41 88 -104 111 -207 75 -64 -23 -122 -19 -172 10 -24
              14 -51 29 -61 32 -29 9 -15 23 67 66 70 37 75 42 55 49 -29 11 -93 1 -134 -20
              -28 -14 -29 -14 -16 1 34 42 254 71 327 44z m-70 -338 c76 -5 146 -11 154 -12
              23 -4 -103 -47 -137 -47 -43 0 -102 23 -183 71 -83 49 -106 74 -27 30 49 -29
              66 -32 193 -42z m-70 -1293 c26 -14 49 -26 51 -26 3 0 -7 17 -23 38 -16 21
              -19 30 -8 20 24 -21 168 -116 214 -141 75 -41 127 -96 169 -176 47 -91 54
              -125 12 -60 -35 53 -120 137 -181 178 -43 29 -67 34 -42 9 22 -22 12 -32 -10
              -11 -13 12 -57 42 -100 67 -42 26 -101 73 -132 107 -58 62 -79 104 -26 51 16
              -17 51 -42 76 -56z m530 -268 c102 -77 134 -147 133 -290 -1 -90 -2 -97 -10
              -53 -4 27 -15 68 -23 90 -8 22 -18 56 -21 75 -18 87 -73 166 -165 233 -25 18
              -25 18 5 1 17 -9 53 -34 81 -56z m349 -165 c8 -31 17 -86 21 -122 3 -36 15
              -108 26 -159 23 -105 19 -130 -8 -50 -21 63 -30 49 -15 -22 6 -28 10 -86 9
              -128 -1 -76 -1 -76 -8 28 -4 60 -14 121 -24 143 -9 20 -23 54 -32 75 -17 37
              -17 37 -26 12 -9 -23 -48 -327 -48 -374 0 -11 -3 -17 -6 -14 -3 4 2 84 11 180
              10 107 14 204 10 253 -8 95 -23 212 -31 240 -12 41 13 -1 41 -67 15 -38 32
              -68 37 -68 6 0 8 40 6 96 -3 85 -2 92 10 64 7 -17 19 -57 27 -87z m160 -258
              c47 -99 53 -165 29 -316 -10 -65 -22 -115 -26 -113 -4 3 -8 51 -9 107 0 56 -4
              125 -10 152 -10 59 -27 203 -34 295 l-4 65 9 -58 c5 -33 25 -92 45 -132z
              m-138 -377 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m150 -180
              c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z"
              onClick={() => onFill(3)}
              fill={fillColors[3]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_05"
              d="M3614 5095 c-16 -13 -17 -16 -4 -25 19 -12 40 -13 40 -1 0 5 3 16 6
              25 8 20 -16 21 -42 1z"
              onClick={() => onFill(4)}
              fill={fillColors[4]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_06"
              d="M3893 5085 c-7 -20 -5 -22 31 -31 l29 -7 -19 26 c-22 30 -32 33 -41
              12z"
              onClick={() => onFill(5)}
              fill={fillColors[5]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_07"
              d="M5750 5249 c-25 -22 -61 -49 -82 -59 -41 -22 -187 -49 -428 -80 -91
              -12 -175 -23 -187 -25 -29 -7 -43 -52 -43 -143 0 -69 3 -81 37 -139 20 -34 40
              -63 44 -63 3 0 14 18 24 40 30 67 170 172 305 228 147 61 245 117 309 176 26
              23 23 17 -13 -25 -63 -75 -124 -119 -231 -169 -154 -71 -171 -80 -211 -121
              -37 -39 -31 -36 169 65 114 59 207 104 207 102 0 -3 -46 -28 -102 -58 -92 -48
              -218 -147 -218 -170 0 -16 63 26 108 72 25 25 43 40 41 33 -7 -21 -160 -172
              -198 -196 -26 -15 -31 -23 -19 -25 22 -4 228 133 307 204 79 72 152 168 197
              259 35 72 53 135 38 135 -5 -1 -29 -19 -54 -41z"
              onClick={() => onFill(6)}
              fill={fillColors[6]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_08"
              d="M5042 4242 c-20 -14 29 -49 81 -57 93 -16 130 -51 143 -135 l6 -39
              35 28 c35 29 103 131 103 155 0 7 -9 21 -20 31 -17 16 -43 19 -178 22 -86 2
              -163 0 -170 -5z"
              onClick={() => onFill(7)}
              fill={fillColors[7]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_09"
              d="M5421 4076 c-13 -59 -56 -116 -86 -116 -14 0 -16 -6 -11 -32 4 -18
              12 -60 17 -92 12 -74 14 -76 49 -76 36 0 78 51 87 103 5 35 -22 230 -36 255
              -5 8 -12 -9 -20 -42z"
              onClick={() => onFill(8)}
              fill={fillColors[8]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_10"
              d="M2865 3156 c-8 -18 -24 -70 -35 -114 l-21 -80 21 -84 c16 -64 33
              -102 74 -164 76 -113 200 -265 294 -357 l79 -79 -16 61 c-15 59 -15 64 8 154
              14 50 24 113 23 139 -2 48 6 60 42 65 21 4 89 -33 226 -123 172 -113 286 -162
              312 -136 16 16 -36 57 -102 82 -171 65 -618 393 -799 586 -43 46 -81 84 -85
              84 -4 0 -13 -15 -21 -34z"
              onClick={() => onFill(9)}
              fill={fillColors[9]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_11"
              d="M2722 2840 c-146 -251 -157 -334 -83 -628 33 -131 135 -628 146 -711
              l7 -54 20 24 c10 13 37 49 60 79 88 119 196 200 266 200 37 0 38 -2 16 -35 -9
              -14 -24 -73 -35 -133 -10 -60 -34 -152 -53 -205 l-34 -97 41 -10 c127 -33 229
              -84 339 -170 222 -174 343 -429 388 -820 6 -52 17 -124 23 -160 l13 -65 90 -3
              90 -3 12 123 c16 160 15 248 -2 388 -22 174 -103 459 -179 630 -44 102 -207
              327 -457 635 -272 335 -365 470 -491 719 -104 206 -118 242 -128 320 l-6 50
              -43 -74z m227 -797 c46 -35 65 -70 68 -130 3 -46 0 -65 -17 -91 -73 -116 -260
              -43 -260 101 0 114 122 184 209 120z"
              onClick={() => onFill(10)}
              fill={fillColors[10]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_12"
              d="M2854 2011 c-72 -44 -83 -101 -30 -158 27 -30 41 -37 70 -37 56 0 81
              31 81 99 0 46 -4 58 -29 84 -35 36 -50 38 -92 12z m56 -25 c0 -2 3 -11 6 -20
              4 -12 0 -16 -15 -16 -14 0 -21 6 -21 20 0 11 7 20 15 20 8 0 15 -2 15 -4z
              m-50 -56 c0 -11 -7 -20 -15 -20 -8 0 -15 9 -15 20 0 11 7 20 15 20 8 0 15 -9
              15 -20z m96 -35 c-9 -34 -48 -52 -78 -37 l-23 12 23 -6 c30 -8 62 21 62 55 0
              18 3 22 11 14 7 -7 9 -23 5 -38z"
              onClick={() => onFill(11)}
              fill={fillColors[11]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_13"
              d="M3317 2636 c-3 -8 -5 -74 -4 -148 2 -117 5 -138 25 -177 13 -24 30
              -51 39 -60 16 -15 15 -16 -9 -19 -23 -3 -27 -9 -30 -45 -4 -31 1 -54 18 -86
              15 -28 21 -54 18 -68 -8 -32 3 -70 22 -77 10 -4 32 4 54 19 79 55 198 85 347
              89 39 1 43 3 43 26 0 21 -5 25 -27 26 -16 1 -53 2 -83 3 l-55 3 60 19 c33 11
              68 22 79 24 24 6 29 11 33 35 2 16 -2 18 -42 14 -26 -3 -68 1 -98 10 -46 13
              -101 23 -171 31 -11 1 -22 7 -24 15 -4 10 4 11 34 4 22 -4 96 -8 166 -9 102
              -1 129 2 133 14 3 7 4 15 2 17 -4 4 -77 12 -119 13 -44 1 -32 21 12 21 64 0
              118 21 123 47 5 28 1 31 -52 38 -71 9 -150 42 -252 107 -217 137 -231 144
              -242 114z"
              onClick={() => onFill(12)}
              fill={fillColors[12]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_14"
              d="M2964 2522 c109 -217 170 -308 319 -472 50 -56 57 -61 57 -39 0 14
              -12 41 -26 60 -37 48 -45 75 -34 104 5 14 6 25 1 25 -19 0 -126 100 -192 179
              -39 46 -91 119 -116 163 -68 116 -72 106 -9 -20z"
              onClick={() => onFill(13)}
              fill={fillColors[13]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_15"
              d="M2520 2543 c-132 -251 -448 -584 -830 -874 -83 -63 -120 -96 -120
              -108 0 -3 16 -17 35 -30 19 -13 71 -62 116 -108 212 -224 371 -529 440 -843
              16 -76 35 -231 55 -453 l6 -77 769 0 769 0 0 48 c0 98 -71 413 -130 575 -119
              325 -368 547 -614 547 -53 0 -66 3 -70 18 -3 9 27 101 69 206 42 104 74 193
              73 197 -4 9 -174 -104 -216 -144 -18 -18 -44 -51 -58 -75 -53 -90 -69 -51
              -158 386 -65 318 -96 517 -105 670 l-6 112 -25 -47z"
              onClick={() => onFill(14)}
              fill={fillColors[14]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_16"
              d="M3897 2416 c-3 -6 -3 -61 -1 -121 5 -128 6 -202 2 -229 -2 -13 7 -23
              29 -32 30 -13 33 -12 45 9 7 12 13 55 13 95 -1 39 1 72 2 72 7 0 25 -92 27
              -134 2 -62 21 -71 43 -19 32 75 19 287 -21 348 -27 42 -43 32 -37 -22 4 -27 6
              -54 5 -60 -1 -7 -2 -25 -3 -40 -2 -42 -16 -16 -16 31 -1 61 -28 114 -59 114
              -14 0 -27 -6 -29 -12z"
              onClick={() => onFill(15)}
              fill={fillColors[15]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_17"
              d="M4155 2210 c-27 -125 -45 -165 -45 -98 0 40 -11 30 -20 -20 l-7 -39
              36 0 c20 0 47 -3 59 -7 l22 -7 0 150 c0 83 -4 151 -9 151 -4 0 -21 -58 -36
              -130z"
              onClick={() => onFill(16)}
              fill={fillColors[16]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_18"
              d="M4080 2004 c0 -8 21 -40 47 -69 42 -49 47 -53 59 -37 7 9 14 29 14
              44 0 21 -9 31 -46 52 -53 30 -74 33 -74 10z"
              onClick={() => onFill(17)}
              fill={fillColors[17]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_19"
              d="M3819 2046 c-2 -2 -22 -6 -45 -9 -22 -3 -68 -16 -102 -29 l-63 -23
              55 -37 55 -36 43 33 c24 17 60 39 81 46 l37 15 -20 22 c-20 21 -32 26 -41 18z"
              onClick={() => onFill(18)}
              fill={fillColors[18]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_20"
              d="M3527 1944 c-27 -14 -66 -28 -87 -32 l-38 -7 80 -95 c264 -315 468
              -640 486 -773 5 -41 23 -62 21 -25 -1 13 2 95 6 183 11 228 11 242 20 523 l8
              254 -69 -7 c-83 -7 -138 -31 -183 -79 -19 -20 -39 -36 -44 -36 -4 0 -20 14
              -35 31 -26 31 -99 89 -111 89 -3 -1 -28 -12 -54 -26z m397 -74 c15 -5 33 -25
              42 -43 14 -30 15 -38 3 -63 -43 -89 -149 -55 -149 48 0 58 43 82 104 58z m20
              -391 c29 -34 27 -61 -5 -96 -48 -50 -119 -16 -119 57 0 78 72 101 124 39z"
              onClick={() => onFill(19)}
              fill={fillColors[19]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_21"
              d="M3858 1825 c-9 -9 3 -54 17 -65 20 -17 55 5 50 30 -2 11 -7 25 -10
              30 -6 10 -48 14 -57 5z"
              onClick={() => onFill(20)}
              fill={fillColors[20]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_22"
              d="M3854 1459 c-12 -19 6 -59 26 -59 25 0 45 34 27 47 -21 17 -46 22
              -53 12z"
              onClick={() => onFill(21)}
              fill={fillColors[21]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_23"
              d="M4047 1723 c4 -137 8 -308 8 -382 -1 -91 2 -126 8 -110 28 72 84 177
              143 267 l66 102 -21 53 c-26 67 -38 119 -40 180 -1 14 -5 16 -19 8 -26 -14
              -50 5 -97 73 -21 31 -42 56 -47 56 -6 0 -6 -98 -1 -247z"
              onClick={() => onFill(22)}
              fill={fillColors[22]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_24"
              d="M4933 1699 c-1 -52 -11 -153 -22 -226 -25 -156 -26 -242 -6 -309 18
              -59 17 -54 5 -54 -15 0 -68 124 -95 220 -13 47 -38 148 -57 225 -30 128 -33
              136 -35 90 -2 -27 -12 -109 -24 -181 -15 -93 -20 -164 -17 -243 2 -90 0 -110
              -10 -106 -8 3 -17 5 -21 5 -4 0 -13 17 -20 38 -7 20 -27 72 -44 115 l-30 77
              -21 -32 c-35 -53 -133 -270 -170 -376 -42 -122 -99 -343 -125 -490 -17 -94
              -19 -137 -14 -257 l6 -145 404 0 403 0 0 88 c0 126 34 452 65 617 16 88 51
              241 86 376 52 205 52 206 -47 424 -7 17 -25 59 -38 95 l-25 65 -1 -92 c0 -51
              -4 -93 -9 -93 -5 0 -11 10 -13 23 -2 17 -6 11 -17 -23 -30 -93 -39 -83 -51 54
              -6 75 -16 123 -32 158 l-23 51 -2 -94z"
              onClick={() => onFill(23)}
              fill={fillColors[23]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_25"
              d="M4337 1660 c-3 -11 -1 -37 4 -57 5 -21 9 -46 9 -55 0 -25 -35 -23
              -52 4 -14 21 -15 21 -30 -18 -9 -21 -32 -73 -50 -114 -142 -311 -159 -412
              -138 -812 7 -133 14 -314 14 -400 l1 -158 26 0 25 0 18 178 c37 382 45 433 98
              610 37 127 92 269 147 381 35 71 41 94 41 146 0 34 -7 85 -16 114 -16 55 -80
              201 -87 201 -3 0 -7 -9 -10 -20z"
              onClick={() => onFill(24)}
              fill={fillColors[24]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_26"
              d="M1527 1483 c-5 -8 -27 -254 -43 -472 -6 -82 -5 -93 8 -88 9 3 36 8
              61 12 203 31 390 -206 375 -472 -5 -94 -37 -163 -108 -232 -67 -66 -135 -93
              -234 -95 -44 0 -96 3 -113 7 l-33 9 0 -51 0 -51 359 0 358 0 7 59 c11 92 -21
              311 -66 461 -81 268 -215 523 -384 725 -115 139 -178 202 -187 188z"
              onClick={() => onFill(25)}
              fill={fillColors[25]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_27"
              d="M5287 1243 c-17 -27 -87 -329 -111 -473 -29 -180 -42 -319 -52 -553
              l-7 -167 167 0 c95 0 166 4 166 9 0 5 -4 43 -9 83 -6 40 -13 103 -16 141 l-7
              67 -94 0 c-52 0 -94 3 -94 6 0 3 11 49 24 102 14 53 45 190 70 303 l46 207
              -30 113 c-44 170 -45 174 -53 162z"
              onClick={() => onFill(26)}
              fill={fillColors[26]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_28"
              d="M5347 762 c-16 -86 -38 -205 -51 -264 l-22 -108 42 0 c52 0 104 10
              104 20 0 5 -22 11 -50 15 -53 7 -56 11 -40 65 22 75 63 317 61 359 -4 92 -17
              66 -44 -87z"
              onClick={() => onFill(27)}
              fill={fillColors[27]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_29"
              d="M1494 900 c-18 -7 -22 -19 -27 -94 -6 -82 -5 -87 18 -111 33 -32 31
              -61 -5 -95 -29 -27 -30 -32 -30 -113 l0 -84 31 -7 c85 -17 177 5 243 58 19 15
              19 17 2 35 -17 19 -15 41 4 41 5 0 22 -12 39 -26 37 -31 41 -57 8 -52 -16 2
              -35 -8 -58 -31 -54 -54 -122 -81 -207 -81 l-73 0 3 -62 3 -63 55 -13 c193 -45
              373 99 373 297 0 172 -105 353 -229 395 -51 17 -116 20 -150 6z m216 -210 c6
              -12 10 -35 8 -53 -2 -25 -8 -33 -26 -35 -47 -7 -68 41 -36 86 19 28 40 28 54
              2z"
              onClick={() => onFill(28)}
              fill={fillColors[28]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            <path
              id="svg_30"
              d="M5383 674 c-31 -192 -29 -213 17 -214 13 0 15 16 12 97 -2 54 -6 120
              -10 147 l-7 49 -12 -79z"
              onClick={() => onFill(29)}
              fill={fillColors[29]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* goat outline */}
            <path
              id="svg_31"
              d="M3845 6256 c-15 -11 -10 -22 49 -109 87 -129 150 -255 170 -344 17
              -76 21 -163 8 -163 -21 0 -55 37 -88 96 -20 36 -62 93 -93 127 -31 33 -65 71
              -77 83 -107 118 -375 258 -579 304 -87 19 -98 -21 -33 -121 51 -80 76 -139
              145 -354 44 -135 57 -191 63 -270 l8 -100 -36 -47 c-20 -27 -39 -45 -43 -40
              -4 4 -12 25 -19 47 -64 205 -285 436 -483 505 -105 37 -100 43 -122 -137 -24
              -191 -24 -354 -1 -440 21 -81 119 -304 156 -357 15 -22 56 -68 90 -101 34 -33
              76 -80 93 -105 27 -39 31 -52 29 -100 -2 -30 6 -108 18 -173 51 -301 9 -715
              -112 -1089 -24 -77 -35 -98 -50 -98 -27 0 -93 -65 -116 -113 -17 -37 -41 -123
              -57 -209 -3 -16 -36 -60 -79 -104 -42 -44 -92 -109 -116 -153 -151 -271 -469
              -605 -896 -943 -138 -109 -159 -134 -180 -215 -37 -140 -114 -1143 -114 -1480
              l0 -53 2054 0 c1864 0 2054 1 2060 16 9 23 7 216 -4 414 -21 364 -77 663 -156
              827 -24 50 -44 101 -44 112 0 27 -67 171 -141 303 l-60 107 -3 128 c-3 132
              -10 162 -76 333 -20 51 -21 65 -14 200 12 212 6 307 -23 408 -64 225 -73 264
              -66 305 9 62 71 152 90 133 4 -4 3 -10 -3 -14 -17 -11 -34 -48 -34 -74 0 -22
              1 -21 19 7 13 22 54 48 156 99 102 52 152 84 192 122 54 53 92 120 93 162 0
              12 9 40 20 62 11 22 20 49 20 61 0 12 12 47 27 77 45 91 37 201 -24 332 -9 19
              -17 53 -18 76 -1 26 -10 53 -24 70 -45 58 -149 201 -190 262 -41 59 -47 92
              -19 92 7 1 31 9 53 20 22 11 45 19 50 20 6 0 51 26 100 58 176 114 295 236
              356 367 27 57 67 220 57 230 -7 7 -87 -26 -146 -61 -60 -37 -111 -50 -382 -98
              -107 -20 -210 -38 -227 -42 -32 -6 -33 -5 -33 25 0 54 -34 102 -160 229 -86
              86 -154 144 -228 193 -96 63 -106 73 -104 97 2 20 -16 51 -73 127 -181 240
              -377 409 -527 456 -16 5 -41 13 -57 18 -21 6 -35 5 -46 -3z m98 -42 c160 -80
              327 -246 487 -484 l58 -86 -64 -12 c-35 -7 -87 -12 -116 -12 l-53 1 34 14 c18
              8 53 15 77 15 26 0 44 5 44 11 0 8 -37 10 -121 8 l-120 -4 24 21 c15 12 53 27
              91 34 37 7 69 16 72 21 7 11 -18 11 -87 0 -30 -5 -71 -12 -91 -15 l-38 -5 14
              27 c22 44 52 64 101 69 25 3 45 10 45 16 0 12 -133 1 -160 -13 -18 -9 -18 -8
              -8 20 12 36 40 57 86 66 18 4 32 10 32 15 0 14 -22 11 -85 -11 -32 -11 -60
              -18 -63 -15 -2 2 4 19 15 37 13 23 30 36 56 42 20 5 37 14 37 19 0 12 -76 0
              -112 -18 -27 -13 -28 -13 -22 13 10 39 13 42 40 42 15 0 24 6 24 15 0 19 -36
              19 -73 1 -27 -15 -27 -15 -21 12 4 15 12 30 18 34 21 14 -4 20 -35 9 l-32 -11
              6 40 c6 44 5 45 -25 29 -24 -13 -40 3 -30 29 4 11 1 14 -11 9 -11 -4 -17 -1
              -17 6 0 7 -12 18 -27 24 -16 6 -22 11 -14 12 7 1 36 -11 64 -25z m-523 -93
              c181 -79 303 -163 416 -284 78 -85 135 -177 110 -177 -9 0 -33 -9 -53 -20 -31
              -16 -48 -18 -109 -13 -63 5 -78 3 -115 -16 -29 -16 -39 -18 -30 -7 24 28 120
              57 197 58 54 1 74 5 74 15 0 31 -176 4 -335 -52 -11 -4 8 20 42 53 64 62 111
              82 198 82 20 0 35 5 35 11 0 16 -129 6 -208 -17 -46 -13 -76 -29 -108 -60 -43
              -40 -45 -40 -39 -15 3 14 15 33 26 41 12 8 42 36 68 62 50 49 110 74 156 62
              19 -5 25 -2 25 10 0 25 -52 20 -163 -15 -90 -28 -99 -34 -117 -67 l-19 -37 -1
              32 c0 21 8 40 23 55 13 13 31 36 41 51 20 33 75 69 94 62 6 -3 19 -8 27 -11
              10 -4 15 0 15 10 0 9 -12 19 -27 22 -42 11 -172 -62 -195 -109 -19 -38 -48
              -66 -33 -31 4 10 14 44 22 74 18 65 33 84 84 107 37 16 51 33 29 33 -22 0 -86
              -40 -127 -78 -48 -46 -55 -39 -41 37 10 47 15 54 52 73 29 16 36 23 24 26 -19
              4 -106 -42 -125 -66 -11 -13 -13 -8 -13 32 0 39 4 49 20 53 11 3 17 9 14 14
              -8 14 -57 -1 -76 -23 -18 -20 -18 -20 -18 11 0 17 5 31 10 31 6 0 10 5 10 11
              0 6 -7 8 -15 5 -8 -3 -21 -8 -28 -11 -12 -5 -47 42 -47 63 0 10 58 -12 230
              -87z m-464 -377 c92 -61 187 -158 249 -253 59 -92 72 -119 116 -245 38 -107
              39 -109 33 -53 -4 36 -3 57 4 57 6 0 32 30 58 67 27 37 81 104 121 149 90 101
              126 119 222 107 81 -9 108 -7 146 16 50 29 82 33 117 15 25 -13 49 -15 109
              -11 55 3 90 1 121 -10 42 -15 101 -14 223 3 36 5 50 -1 138 -57 72 -45 136
              -98 240 -201 138 -135 142 -140 142 -181 0 -33 -10 -58 -48 -117 -54 -84 -55
              -105 -7 -155 16 -16 96 -132 179 -257 83 -125 171 -252 196 -282 25 -31 45
              -57 45 -59 0 -2 -39 3 -87 10 -104 16 -254 13 -277 -6 -26 -22 -20 -82 13
              -126 34 -46 210 -205 227 -205 31 0 82 -118 70 -165 -6 -25 -7 -25 -115 -25
              -210 0 -415 30 -518 76 -29 12 -76 44 -104 71 -29 26 -47 39 -41 28 5 -11 23
              -32 39 -46 116 -108 331 -163 691 -176 89 -3 165 -10 168 -15 11 -17 -29 -48
              -79 -63 -65 -19 -213 -19 -340 0 -187 28 -287 64 -365 130 -23 20 -42 32 -42
              26 0 -5 19 -25 43 -44 133 -109 376 -174 617 -165 66 2 120 1 120 -2 0 -15
              -81 -118 -104 -134 -34 -22 -43 -20 -21 4 10 11 15 20 12 20 -4 0 -24 -18 -44
              -41 -32 -35 -80 -69 -98 -69 -3 0 2 15 11 33 13 23 13 29 3 20 -14 -11 -117
              -53 -131 -53 -4 0 9 16 30 35 l37 36 -55 -25 c-30 -14 -99 -38 -152 -53 -53
              -15 -96 -32 -95 -38 1 -6 -31 -12 -73 -15 l-75 -5 98 -8 c53 -5 97 -12 97 -16
              0 -4 -6 -13 -12 -19 -9 -9 -13 -45 -13 -110 1 -77 5 -109 24 -155 26 -67 38
              -70 20 -6 -19 71 -16 177 7 229 20 43 54 83 54 63 0 -6 -8 -25 -17 -44 -29
              -56 -23 -156 15 -269 51 -150 62 -219 62 -390 0 -98 -3 -151 -10 -144 -11 11
              -79 256 -81 293 -1 20 -3 21 -6 6 -6 -32 43 -302 76 -410 16 -55 45 -145 64
              -200 30 -84 60 -251 44 -235 -3 3 -15 43 -26 90 -19 76 -168 406 -178 396 -2
              -2 16 -50 40 -107 53 -125 70 -177 96 -289 20 -85 38 -250 28 -250 -3 0 -13
              22 -21 48 -9 27 -37 82 -63 123 -55 88 -110 203 -122 256 l-9 38 -1 -51 c-1
              -63 22 -145 59 -205 15 -25 31 -55 35 -68 13 -43 6 -217 -16 -346 -13 -83 -19
              -155 -16 -198 10 -152 -32 2 -52 193 -16 145 -42 232 -105 359 -75 148 -89
              207 -90 368 -1 73 -4 129 -8 125 -4 -4 -10 -64 -14 -133 -8 -147 7 -235 58
              -339 29 -60 31 -73 32 -175 1 -110 -30 -325 -46 -325 -4 0 -8 8 -8 18 0 9 -25
              109 -55 222 -77 285 -88 357 -87 588 0 105 -4 192 -8 192 -10 0 -27 -102 -35
              -210 -13 -157 28 -398 100 -595 21 -55 45 -125 55 -155 10 -30 21 -63 25 -72
              4 -10 3 -18 -3 -18 -6 0 -14 12 -20 28 -5 15 -49 86 -97 157 -105 157 -128
              201 -155 296 -29 106 -34 182 -20 314 6 64 9 119 7 121 -3 3 -12 -39 -21 -93
              -38 -222 -46 -267 -51 -271 -10 -10 -5 145 11 338 17 202 14 412 -6 500 -20
              86 -31 122 -36 118 -2 -3 3 -34 13 -69 13 -49 17 -100 16 -219 -1 -85 -6 -168
              -11 -185 -9 -27 -10 -23 -12 35 -5 136 -28 166 -46 60 l-11 -65 -6 55 c-3 30
              -9 92 -12 138 -6 96 -35 245 -69 364 -29 97 -106 301 -112 295 -3 -2 4 -27 15
              -54 39 -100 122 -495 107 -510 -4 -5 -11 17 -37 122 -15 59 -53 163 -88 239
              -49 108 -131 222 -261 366 -124 136 -175 205 -210 283 -10 23 -19 37 -19 30
              -3 -39 82 -173 200 -319 115 -143 155 -204 197 -299 82 -188 117 -460 66 -516
              -22 -25 -70 -24 -168 1 -61 15 -104 37 -214 107 -201 128 -451 307 -479 343
              -62 78 -70 199 -24 355 38 124 78 327 94 475 l13 115 18 -53 c25 -72 88 -185
              139 -247 76 -93 152 -175 160 -175 5 0 -14 25 -43 56 -54 60 -135 214 -164
              313 -25 86 -19 83 35 -19 28 -52 56 -99 61 -105 14 -14 11 -7 -49 115 -85 170
              -167 479 -183 690 -5 67 -14 118 -25 139 -9 19 -61 80 -114 136 -88 92 -102
              113 -141 201 -23 55 -46 104 -50 109 -4 6 -20 46 -36 90 -27 77 -28 89 -32
              313 -2 128 -1 243 2 257 l6 25 63 -31 c34 -17 98 -55 143 -85z m2850 -486
              c-19 -95 -127 -261 -232 -357 -72 -66 -287 -211 -311 -210 -15 0 -13 3 7 17
              37 24 210 194 210 206 0 5 -19 -10 -43 -35 -45 -46 -107 -87 -107 -71 0 24
              125 121 218 170 56 30 102 55 102 58 0 2 -93 -43 -207 -102 -200 -101 -206
              -104 -169 -65 40 41 57 50 211 121 107 50 168 94 231 169 36 42 39 48 13 25
              -63 -59 -209 -139 -349 -194 -92 -36 -239 -152 -265 -210 -21 -48 -30 -44 -75
              35 -26 45 -30 62 -30 127 0 91 14 136 43 143 12 2 96 14 187 25 376 49 424 62
              510 139 25 22 49 40 54 41 5 0 6 -14 2 -32z m-466 -1016 c34 -5 48 -13 59 -33
              14 -25 13 -30 -27 -90 -24 -35 -56 -74 -71 -86 l-29 -22 -6 39 c-13 84 -50
              119 -143 135 -51 8 -102 43 -81 56 15 10 233 11 298 1z m125 -240 c10 -57 15
              -119 12 -139 -9 -52 -51 -103 -87 -103 -35 0 -37 2 -49 76 -5 32 -13 73 -16
              90 -6 28 -4 32 19 38 33 8 73 69 82 125 9 58 18 39 39 -87z m-2494 -896 c181
              -193 627 -520 801 -586 64 -25 116 -66 100 -82 -26 -26 -139 23 -301 129 -185
              121 -234 143 -267 119 -12 -9 -15 -23 -12 -52 3 -22 -3 -67 -14 -104 -29 -99
              -33 -169 -14 -215 16 -39 14 -37 -64 40 -95 93 -211 234 -292 355 -44 65 -62
              104 -79 168 l-22 84 23 81 c25 93 46 147 56 147 4 0 42 -38 85 -84z m-181
              -332 c7 -21 59 -129 114 -240 118 -233 222 -385 482 -704 237 -292 374 -478
              442 -601 17 -30 51 -115 77 -189 121 -349 152 -572 123 -868 l-12 -123 -90 3
              -90 3 -13 65 c-6 36 -17 108 -23 160 -44 389 -161 638 -384 816 -111 88 -213
              140 -342 173 l-41 11 38 112 c21 62 44 154 50 203 8 59 19 97 31 111 31 35 23
              47 -28 41 -82 -9 -151 -68 -289 -246 l-40 -52 -8 48 c-24 142 -113 570 -149
              718 -33 138 -41 188 -41 265 0 116 16 166 105 323 l63 112 6 -51 c4 -28 12
              -69 19 -90z m618 -158 c31 -18 100 -61 154 -94 109 -70 175 -99 243 -107 59
              -7 63 -9 58 -38 -5 -26 -59 -47 -123 -47 -67 0 -45 -17 31 -23 79 -7 82 -8 74
              -29 -5 -11 -30 -14 -138 -12 -73 1 -147 5 -166 9 -24 5 -32 3 -29 -6 4 -13 14
              -15 90 -23 26 -3 71 -12 100 -21 31 -8 73 -13 100 -10 43 4 48 3 45 -15 -4
              -24 -9 -29 -33 -35 -11 -2 -40 -11 -66 -19 -25 -8 -48 -12 -51 -10 -3 3 -8 1
              -12 -5 -4 -7 12 -12 47 -12 116 -4 108 -1 108 -31 0 -28 0 -28 -72 -29 -140
              -3 -245 -30 -318 -84 -40 -29 -44 -30 -64 -9 -10 10 -15 32 -15 62 1 30 -6 60
              -18 82 -26 46 -21 120 8 120 24 0 24 15 -1 42 -35 38 -48 100 -49 228 0 67 3
              128 6 136 8 22 30 17 91 -20z m-453 -43 c48 -83 92 -146 147 -210 59 -69 144
              -146 170 -156 14 -5 16 -11 8 -32 -11 -29 -3 -55 34 -104 14 -19 26 -46 26
              -60 0 -22 -6 -18 -54 36 -149 164 -205 246 -304 440 -34 67 -62 124 -62 127 0
              14 10 3 35 -41z m-375 -353 c26 -175 122 -649 153 -757 27 -96 43 -102 85 -36
              17 27 44 60 59 74 38 36 213 151 213 141 0 -9 -115 -302 -137 -349 -8 -17 -12
              -41 -8 -52 6 -18 15 -21 71 -21 74 0 189 -34 257 -76 150 -94 283 -269 357
              -471 59 -162 130 -477 130 -575 l0 -48 -769 0 -769 0 -6 77 c-32 353 -49 460
              -106 638 -42 134 -155 358 -238 475 -64 91 -230 270 -281 303 l-25 17 25 26
              c13 14 60 54 104 87 385 292 736 666 837 892 12 27 13 21 19 -85 4 -63 17
              -180 29 -260z m1385 178 c10 -18 19 -55 21 -83 4 -64 5 -66 13 -30 3 17 4 56
              1 88 -4 42 -2 57 7 57 58 0 93 -269 49 -374 -20 -47 -41 -43 -42 10 -1 53 -14
              123 -24 129 -5 3 -6 -16 -4 -42 3 -27 0 -65 -8 -88 -11 -34 -17 -40 -38 -37
              -14 2 -29 7 -33 11 -9 9 -19 336 -10 369 8 35 48 29 68 -10z m235 -204 c0
              -154 0 -155 -22 -149 -11 4 -38 7 -58 7 l-37 -1 7 40 c9 51 20 62 20 21 0 -46
              16 -39 25 11 5 23 9 44 9 47 1 3 10 41 20 85 32 139 36 132 36 -61z m-332
              -177 c10 -11 4 -16 -28 -27 -22 -7 -57 -28 -78 -46 l-38 -32 -57 36 c-31 19
              -56 37 -54 39 10 9 123 44 160 50 23 3 44 7 46 9 5 5 36 -13 49 -29z m288 -23
              c35 -20 44 -31 44 -52 0 -15 -7 -35 -14 -44 -12 -16 -17 -12 -59 37 -72 83
              -59 110 29 59z m-495 -84 c34 -33 64 -60 68 -60 4 0 23 16 42 36 45 48 102 73
              184 79 l68 6 -8 -243 c-3 -134 -8 -274 -11 -313 -6 -122 -17 -379 -16 -397 0
              -10 -3 -18 -9 -18 -5 0 -9 11 -9 24 0 56 -96 256 -188 394 -61 90 -227 306
              -327 425 -56 67 -56 67 -28 67 15 0 55 13 88 29 33 16 66 30 72 30 7 1 40 -26
              74 -59z m434 4 c47 -68 71 -87 97 -73 14 8 18 6 19 -8 5 -62 17 -117 40 -178
              l21 -56 -63 -97 c-64 -98 -126 -212 -144 -266 -8 -23 -10 4 -10 110 0 76 -4
              248 -8 382 -4 137 -4 242 1 242 5 0 26 -25 47 -56z m895 -326 c5 -57 9 -107
              10 -111 1 -24 26 6 41 49 11 31 18 41 18 27 1 -13 6 -23 11 -23 6 0 10 38 10
              93 l1 92 33 -85 c18 -47 50 -122 70 -167 55 -123 55 -144 7 -333 -92 -357
              -151 -746 -151 -992 l0 -88 -403 0 -404 0 -6 145 c-6 127 -3 161 17 273 58
              314 157 606 280 830 34 61 30 64 81 -73 20 -55 38 -101 39 -101 0 -1 10 -4 21
              -8 19 -6 20 -2 17 108 -3 82 2 146 17 234 12 66 21 149 22 184 l1 63 28 -110
              c15 -60 39 -157 53 -216 22 -96 76 -240 98 -263 17 -18 18 0 4 49 -20 66 -19
              153 6 308 11 73 21 174 22 226 l2 94 23 -51 c15 -35 26 -84 32 -154z m-597 0
              c67 -159 75 -246 31 -339 -79 -163 -128 -287 -168 -431 -48 -166 -56 -219 -92
              -590 l-18 -178 -25 0 -26 0 -1 158 c0 86 -7 267 -14 400 -21 403 -8 484 141
              820 62 140 64 143 80 123 10 -12 24 -21 33 -21 18 0 20 18 7 74 -9 39 -6 66 9
              66 4 0 23 -37 43 -82z m-2638 -343 c128 -163 240 -373 313 -587 68 -194 109
              -433 96 -549 l-7 -59 -358 0 -359 0 0 51 0 51 33 -9 c17 -4 68 -8 112 -7 67 0
              89 5 138 28 125 62 197 167 205 300 16 265 -172 502 -375 471 -25 -4 -52 -9
              -61 -12 -13 -5 -14 7 -8 93 14 192 37 449 42 466 4 13 24 -4 86 -70 44 -48
              109 -123 143 -167z m3585 -164 l30 -113 -46 -207 c-25 -113 -56 -250 -70 -303
              -13 -53 -24 -99 -24 -102 0 -3 42 -6 94 -6 l94 0 7 -67 c3 -38 10 -101 16
              -141 5 -40 9 -78 9 -83 0 -5 -71 -9 -166 -9 l-167 0 7 167 c10 234 23 373 52
              553 24 144 94 446 111 473 8 12 9 8 53 -162z m51 -232 c2 -42 -39 -284 -61
              -359 -16 -54 -13 -58 40 -65 28 -4 50 -10 50 -15 0 -10 -52 -20 -104 -20 l-42
              0 22 108 c13 59 35 178 51 264 27 153 40 179 44 87z m-3747 45 c124 -42 229
              -223 229 -395 0 -116 -67 -225 -166 -273 -66 -32 -137 -40 -207 -24 l-55 13
              -3 63 -3 62 73 0 c85 0 153 27 207 81 23 23 42 33 58 31 33 -5 29 21 -8 52
              -17 14 -34 26 -39 26 -19 0 -21 -22 -4 -41 17 -18 17 -20 -2 -35 -66 -53 -158
              -75 -243 -58 l-31 7 0 84 c0 81 1 86 30 113 36 34 38 63 5 95 -23 24 -24 29
              -18 111 5 75 9 87 27 94 34 14 99 11 150 -6z m3762 -225 c3 -41 6 -105 8 -142
              2 -68 2 -68 -23 -65 -24 3 -26 7 -26 48 0 50 26 242 32 236 2 -2 6 -37 9 -77z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* left ear inside - black */}
            <path
              id="svg_32"
              d="M2836 5705 c7 -19 14 -54 14 -77 1 -24 7 -70 15 -103 8 -33 15 -68
              15 -79 0 -16 -2 -16 -16 -5 -22 18 -44 64 -44 94 0 14 -4 25 -9 25 -10 0 -8
              -14 21 -115 11 -39 33 -87 50 -108 l30 -38 -26 -40 c-24 -35 -24 -52 -1 -30 6
              5 20 12 32 15 19 6 23 2 28 -31 3 -21 10 -54 16 -73 8 -27 7 -43 -6 -74 -9
              -21 -14 -40 -12 -42 2 -2 15 23 30 56 14 33 29 60 34 60 12 0 43 -109 52 -183
              l7 -62 7 53 c4 28 12 52 17 52 6 0 10 9 10 20 0 32 12 23 64 -48 27 -37 47
              -62 44 -57 -2 6 -20 44 -41 85 -46 92 -48 113 -9 104 42 -10 81 -33 95 -54 6
              -11 16 -20 21 -20 5 0 -32 41 -83 90 -50 50 -91 94 -91 98 1 4 17 15 36 24 42
              19 73 12 98 -24 9 -12 16 -17 16 -9 0 23 -56 69 -108 87 l-52 19 0 85 c0 88
              -13 154 -31 166 -8 4 -7 0 0 -14 16 -30 14 -84 -5 -128 l-17 -39 -22 80 c-20
              74 -93 231 -102 221 -3 -2 3 -19 12 -37 13 -24 16 -46 11 -82 -3 -27 -8 -52
              -12 -56 -3 -3 -16 6 -29 21 -17 20 -25 45 -30 95 -8 76 -20 113 -34 113 -6 0
              -4 -15 5 -35z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* left eyebrow - black */}
            <path
              id="svg_33"
              d="M3885 5327 c37 -14 135 -90 223 -172 72 -67 69 -54 -10 49 -66 86
              -89 103 -163 121 -72 17 -91 18 -50 2z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* right eyebrow */}
            <path
              id="svg_34"
              d="M4833 5203 c-20 -19 -34 -43 -38 -69 -4 -21 -9 -48 -11 -59 -3 -11 6
              -2 20 20 73 116 84 160 29 108z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* left eye */}
            <path
              id="svg_35"
              d="M3695 5204 c-78 -16 -146 -38 -157 -52 -12 -14 -10 -14 17 0 41 21
              106 31 134 20 23 -8 23 -9 -15 -28 -130 -67 -141 -76 -106 -87 9 -4 36 -18 60
              -32 50 -30 106 -33 176 -9 31 11 66 15 99 11 58 -5 85 -30 113 -104 9 -24 20
              -43 25 -43 16 0 22 91 9 133 -17 55 -132 169 -188 185 -38 11 -124 14 -167 6z
              m-39 -110 c-3 -9 -6 -20 -6 -25 0 -12 -21 -11 -40 1 -13 9 -12 12 4 25 26 20
              50 19 42 -1z m279 -20 l17 -27 -28 7 c-36 9 -38 11 -31 31 9 22 22 19 42 -11z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* left eye bag */}
            <path
              id="svg_36"
              d="M3550 4926 c0 -10 148 -96 189 -111 61 -21 98 -19 167 10 57 23 58
              24 24 25 -19 0 -88 5 -153 10 -113 9 -184 30 -202 60 -6 10 -25 14 -25 6z"
              onClick={() => onFill(35)}
              fill={fillColors[35]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* beard line 1 */}
            <path
              id="svg_37"
              d="M3620 3641 c0 -24 118 -134 188 -177 43 -25 87 -55 100 -67 26 -24
              29 -16 5 20 -15 23 -11 22 42 -15 69 -47 163 -141 194 -192 32 -54 25 -16 -11
              58 -36 73 -112 154 -175 187 -62 32 -213 135 -213 146 0 5 -5 9 -11 9 -5 0 2
              -16 17 -35 14 -19 24 -35 21 -35 -14 0 -101 56 -127 82 -17 16 -30 25 -30 19z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* beard line 2 */}
            <path
              id="svg_38"
              d="M4170 3353 c58 -42 110 -97 129 -136 23 -48 69 -200 81 -267 6 -37 8
              -26 9 58 1 110 -8 145 -56 214 -25 37 -100 99 -158 132 -30 17 -30 17 -5 -1z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* beard line 3 */}
            <path
              id="svg_39"
              d="M4568 3156 c2 -56 0 -96 -6 -96 -5 0 -22 30 -37 68 -28 66 -53 108
              -41 67 25 -85 40 -323 27 -435 -13 -121 -22 -248 -16 -235 2 6 13 93 25 194
              22 195 31 234 48 191 6 -14 20 -47 32 -75 16 -35 24 -81 30 -155 7 -104 7
              -105 8 -28 1 42 -3 100 -9 128 -15 71 -6 85 15 22 27 -80 31 -55 8 50 -11 51
              -23 123 -26 159 -6 68 -26 155 -48 209 -12 28 -13 21 -10 -64z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* beard line 4 */}
            <path
              id="svg_40"
              d="M4715 3000 c7 -92 24 -236 34 -295 6 -27 10 -93 11 -145 0 -52 4
              -100 8 -107 4 -7 16 40 26 106 24 150 18 212 -29 314 -20 42 -40 103 -45 135
              l-9 57 4 -65z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* beard line dot 1 */}
            <path
              id="svg_41"
              d="M4621 2504 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* beard line dot 2 */}
            <path
              id="svg_42"
              d="M4772 2330 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
              onClick={() => onFill(41)}
              fill={fillColors[41]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* jacket small smiley outline */}
            <path
              id="svg_43"
              d="M2814 2051 c-99 -61 -100 -201 -2 -261 102 -62 208 -6 208 110 -1 70
              -30 123 -82 149 -55 26 -84 27 -124 2z m132 -52 c25 -26 29 -38 29 -84 0 -68
              -25 -99 -81 -99 -29 0 -43 7 -70 37 -53 57 -42 114 30 158 42 26 57 24 92 -12z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* jacket small smiley right eye */}
            <path
              id="svg_44"
              d="M2880 1970 c0 -14 7 -20 21 -20 15 0 19 4 15 16 -3 9 -6 18 -6 20 0
              2 -7 4 -15 4 -8 0 -15 -9 -15 -20z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* jacket small smiley left eye */}
            <path
              id="svg_45"
              d="M2830 1930 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20 -8
              0 -15 -9 -15 -20z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* jacket small smiley mouth */}
            <path
              id="svg_46"
              d="M2940 1919 c0 -34 -32 -63 -62 -55 l-23 6 23 -12 c16 -8 28 -8 47 0
              28 13 43 58 26 75 -8 8 -11 4 -11 -14z"
              onClick={() => onFill(45)}
              fill={fillColors[45]}
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* shirt button top outline */}
            <path
              id="svg_47"
              d="M3837 1862 c-36 -39 -14 -122 36 -143 37 -16 75 2 96 45 34 73 -79
              156 -132 98z m81 -45 c23 -27 -10 -79 -39 -62 -14 9 -30 55 -23 66 8 13 50 11
              62 -4z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
             {/* shirt button bottom outline */}
            <path
              id="svg_48"
              d="M3841 1501 c-28 -28 -29 -93 -1 -121 44 -44 120 -8 120 56 0 60 -81
              103 -119 65z m57 -47 c18 -12 20 -19 12 -35 -15 -27 -48 -24 -56 5 -6 25 1 46
              14 46 4 0 18 -7 30 -16z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
            {/* jacket sleeve large smile right eye */}
            <path
              id="svg_49"
              d="M1656 688 c-32 -45 -11 -93 36 -86 18 2 24 10 26 35 6 63 -32 94 -62
              51z"
              fillRule="evenodd"
              stroke="#000000"
              strokeWidth="1"
            />
        </g>
      </svg>
    </div>
  );
};

export default NftColoring;
